import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { MyleDSQMedicationItem } from "./MyleDSQMedicationItem";

class MyleDSQMedication implements ITableDataSourceItem<MyleDSQMedicationItem> {
    public Model: MyleDSQMedicationItem;
    public IsSelected: boolean;
    public Name: string;
    public IsAlreadyInMyle: boolean;
    public MyleMedicationId: string;

    constructor(model: MyleDSQMedicationItem) {
        this.Model = model;
        this.IsSelected = false;
        this.IsAlreadyInMyle = false;
    }
}

export { MyleDSQMedication };
